// trackingApiUrlMap is not exported from @qubictron/url — Rail search API disabled for now.
// import { trackingApiUrlMap } from "@qubictron/url";
import axios from "axios";
import { RailQueryParams } from "./query.types";
import { RailResponseDTO } from "./response.types";
import { injectAuthHeader, injectDataInterceptor } from "shared/api/utils/api.utils";

// const TRACKING_URL = trackingApiUrlMap
//   .prod()
//   .setPathname("rail")
//   .handleQueryParams((qp) => {
//     qp.set("api_key", "1");
//   })
//   .build();
const TRACKING_URL = "";

const requestInstance = axios.create();
requestInstance.defaults.baseURL = TRACKING_URL;
injectDataInterceptor(requestInstance);
injectAuthHeader(requestInstance);

class RailSearchService {
  public search(params: RailQueryParams, signal?: AbortSignal): Promise<RailResponseDTO> {
    return requestInstance.get("", {
      params,
      ...(signal ? { signal } : {}),
    });
  }
}

export const railSearchService = new RailSearchService();
